import { gql } from '@apollo/client'

export interface TaxAddress {
  countryCode: string
  postCode: string
  stateCode: string
  city: string
  street: string
}

export interface TaxLineItem {
  id: string
  quantity: string
  taxCode: string
  unitPrice: string
  discount: string
}

export interface CalculateTaxInput {
  destinationAddress: TaxAddress
  shippingAmount: string
  lineItems: TaxLineItem[]
  outletId: string
}

export interface LineItemTax {
  rateId: string
  rateName: string
  rate: string
  totalTax: string
  groupRateId: string
}

export interface ResponseLineItem {
  id: string
  taxes: LineItemTax[]
}

export const CalculateTaxErrorTypes = {
  POSTCODE_NOT_IN_STATE: 'POSTCODE_NOT_IN_STATE',
  INACTIVE_TAX_CATEGORY: 'INACTIVE_TAX_CATEGORY',
  UNSPECIFIED: 'UNSPECIFIED',
} as const

export type CalculateTaxErrorType = typeof CalculateTaxErrorTypes[keyof typeof CalculateTaxErrorTypes]

export interface CalculateTaxError {
  type: CalculateTaxErrorType
  message: string
  inactiveTaxCodes?: string[]
  lineItemIds?: string[]
}

export interface CalculateTaxResponse {
  calculateTax: {
    lineItems: ResponseLineItem[]
    error?: CalculateTaxError
  }
}

export const CalculateTax = gql`
  mutation CalculateTaxMutation($input: CalculateTaxInput!) {
    calculateTax(input: $input) {
      lineItems {
        id
        taxes {
          rate
          rateId
          rateName
          totalTax
          groupRateId
        }
      }
      error {
        type
        message
        inactiveTaxCodes
        lineItemIds
      }
    }
  }
`
